import React, { Component } from 'react';
import './App.css';
// import 'react-h5-audio-player/lib/styles.less' Use LESS
// import 'react-h5-audio-player/src/styles.scss' Use SASS
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
// npm install --save-dev @iconify/react @iconify-icons/clarity
// import { Icon, InlineIcon } from '@iconify/react';
import playSolid from '@iconify-icons/clarity/play-solid';
class App extends Component {
  render() {
    return (
      <div className="App">
      <header className="App-header"><p>
          Ad Auris Audio React Widget Demo
        </p>   
        <div class="widgetDiv">
        <AudioPlayer class='WidgetTest'
          src="https://storage.googleapis.com/ad-auris-django-bucket/media/A%20Doll%20Like%20Me%20mp3%20%20-%202020-12-05%2C%205.57%20PM.mp3" 
          defaultCurrentTime="Loading" 
          defaultDuration="Loading" 
          showSkipControls={true}
          onPlay={e => console.log("onPlay")}
          stopOthersOnPlay={true}

          
          
          
          
          
        />
        </div>
      </header>
      
    </div>
    
    );
  }
}
export default App;

